import Context from './index';
import React, { useState } from 'react';

const TableProvider = (props) => {
    const [data] = useState([]);

    return (
        <Context.Provider
            value={{
                ...props,
                data
            }}
        >
            {props.children}
        </Context.Provider>
    );
};

export default TableProvider;